const styles = {
  container: {
    padding: 8,
    "@media screen and (max-width : 1200px)": {
      width: "auto",
      paddingTop: 17,
    },
  },
  anchor: {
    height: 46,
    borderRadius: "0 0 4px 4px",
    boxShadow: "0 1px 4px 0 rgba(0,0,0,0.3)",
    textDecoration: "none",
    cursor: "pointer",
    display: "inline-block",
    marginRight: "10px",
  },
  buttonText: {
    color: (props: any) => (props.highContrast ? "#000" : "#fff"),
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: "46px", // Line height in specs is 18.  But to center things vertically, it should match the height of the anchor
    textAlign: "center",
  },
  scheduleVisit: {
    padding: "0 18px",
    "@media screen and (max-width : 1200px)": {
      display: "none",
    },
  },
  learnMore: {
    padding: "0 18px",
  },
  applyOnline: {
    padding: "0 18px",
    "@media screen and (max-width : 1200px)": {
      display: "none",
    },
  },
  registerNow: {
    padding: "0 18px",
  },
  personalize: {
    position: "relative",
    marginRight: "16px",
  },
  starsIcon: {
    position: "absolute",
    top: "-1px",
    right: "-24px",
  },
};
export default styles;
